import React from 'react';
import styles from './OrderStepper.module.css';

const steps = ['Products', 'Customer', 'Review', 'Confirm'];

const stepIcons = [
  <svg viewBox="0 0 24 24" fill="currentColor"><path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z"/></svg>,
  <svg viewBox="0 0 24 24" fill="currentColor"><path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5z"/></svg>,
  <svg viewBox="0 0 24 24" fill="currentColor"><path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"/></svg>,
  <svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/></svg>,
];

interface OrderStepperProps {
  currentStep: number;
}

export const OrderStepper: React.FC<OrderStepperProps> = ({ currentStep }) => {
  return (
    <div className={styles.stepper}>
      {steps.map((label, idx) => {
        const isCompleted = idx < currentStep;
        const isActive = idx === currentStep;
        return (
          <React.Fragment key={label}>
            <div className={styles.stepItem}>
              <div className={`${styles.circle} ${isCompleted ? styles.completed : isActive ? styles.active : styles.upcoming}`}>
                {isCompleted ? (
                  <svg viewBox="0 0 24 24" fill="currentColor"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg>
                ) : (
                  stepIcons[idx]
                )}
              </div>
              <span className={`${styles.label} ${isActive ? styles.labelActive : isCompleted ? styles.labelCompleted : ''}`}>
                {label}
              </span>
            </div>
            {idx < steps.length - 1 && (
              <div className={`${styles.connector} ${idx < currentStep ? styles.connectorDone : ''}`} />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};
